'use strict';

import Component from '_core_ext/components/Component';

export default class MobileAccountNavigationToggler extends Component {
    init() {
        super.init();
        this.event('click', '.js-account-menu-toggle', this.onNavigationToggleClick);
        this.event('click', '.js-overlay-menu', this.onOverlayCloseMenu);
        this.eventMgr('stickyheader.stickyheaderclicked', this.onHeaderClick);
        this.event('keydown', '.js-account-menu-content', this.keyDownHandler);
        this.initCache();
    }

    initCache() {
        let menuItems = $('.js-account-menu-content').find('a');
        let l = menuItems.length;
        this.firstItem = l > 0 ? menuItems[0] : null;
        this.lastItem = l > 0 ? menuItems[l - 1] : null;
    }

    keyDownHandler(el, event) {
        if (event.key === 'Tab') {
            if (event.target === this.firstItem && event.shiftKey ||
                event.target === this.lastItem && !event.shiftKey)
            {
                this.onHeaderClick();
            }
        }
    }

    onNavigationToggleClick() {
        this.$el.find('.js-account-menu-state').toggleClass('is-active');
        this.$el.find('.js-overlay-menu').toggleClass('active');

        if (this.$el.find('.js-account-menu-state').hasClass('is-active')) {
            this.$el.find('.js-account-menu-toggle').attr('aria-expanded', 'true');
        } else {
            this.$el.find('.js-account-menu-toggle').attr('aria-expanded', 'false');
        }
    }

    onOverlayCloseMenu() {
        this.onNavigationToggleClick();
    }

    onHeaderClick() {
        if (this.$el.find('.js-account-menu-state').hasClass('is-active')) {
            this.onNavigationToggleClick();
        }
    }
}

module.exports = MobileAccountNavigationToggler;
